import React from "react";
import { createContext, useReducer } from "react";

const initialCuru = {
  ratingChanges: {
    flag: 0,
    productId: 0,
  },
};

export const CuruContext = createContext(null);

export function CuruProvider({ children }) {
  const [curu, dispatch] = useReducer(curuReducer, initialCuru);

  // add a reducer method here that calls the state to change the value of the state.
  const refreshRating = (rating) =>
    dispatch({ type: "REFRESH_RATING", payload: rating });

  return (
    <CuruContext.Provider value={{ ...curu, refreshRating }}>
      {children}
    </CuruContext.Provider>
  );
}

function curuReducer(curu, action) {
  switch (action.type) {
    // 需要在这下面写上更改state的值的具体代码
    case "REFRESH_RATING":
      return {
        ...curu,
        ratingChanges: {
          flag: curu.ratingChanges.flag++,
          productId: action.payload.productId,
        },
      };

    default: {
      throw Error("Unknown action: " + action.type);
    }
  }
}
